import { LogoContainer } from 'reservations/payments/components/LogoContainer';

export function GenericCardLogo() {
  return (
    <LogoContainer>
      <svg
        data-testid="genericcard-logo"
        width="32"
        height="20"
        viewBox="0 0 32 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.9745 18.9286C31.9745 19.5153 31.49 20 30.9036 20H1.07092C0.484462 20 0 19.5153 0 18.9286V1.07143C0 0.484694 0.484462 0 1.07092 0H30.9291C31.5155 0 32 0.484694 32 1.07143V18.9286H31.9745Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.9745 17.9286H31V1.07143C31 1.05834 30.9952 1.04061 30.9772 1.02263C30.9592 1.00464 30.9417 1 30.9291 1H1.07092C1.05829 1 1.04079 1.00464 1.02281 1.02263C1.00484 1.04061 1 1.05834 1 1.07143V18.9286C1 18.9417 1.00484 18.9594 1.02281 18.9774C1.04079 18.9954 1.05829 19 1.07092 19H30.9036C30.9162 19 30.9337 18.9954 30.9517 18.9774C30.9697 18.9594 30.9745 18.9417 30.9745 18.9286V17.9286ZM31.9745 18.9286C31.9745 19.5153 31.49 20 30.9036 20H1.07092C0.484462 20 0 19.5153 0 18.9286V1.07143C0 0.484694 0.484462 0 1.07092 0H30.9291C31.5155 0 32 0.484694 32 1.07143V18.9286H31.9745Z"
          fill="#EEEEEE"
        />
        <rect x="1" y="4" width="30" height="4" fill="#EEEEEE" />
        <rect x="3" y="13" width="6" height="2" rx="1" fill="#EEEEEE" />
        <rect x="11" y="13" width="8" height="2" rx="1" fill="#EEEEEE" />
      </svg>
    </LogoContainer>
  );
}
